import { UsageSearchFormValues, UsageSummary } from "./types";

export const initialUsageSearchForm: UsageSearchFormValues = {
  dateFrom: null,
  dateTo: null,
  pricingKeyCode: "",
  userId: "",
  isSuccess: "",
  search: "",
};

/** Prazan zbroj, dok stvarni ne stigne s poslužitelja. */
export const initialUsageSummary: UsageSummary = {
  count: 0,
  total: 0,
};

/**
 * Nazivi vrsta u sučelju. Ključevi dolaze iz cjenika, pa se ovdje samo prevode u ono što
 * korisnik prepoznaje.
 */
export const USAGE_KEY_LABELS: Record<string, string> = {
  "cijena.cvh": "Izračun cijene vozila",
  "cijena.sms": "SMS poruka",
  "cijena.ocr": "Učitani ulazni račun",
};
